import { supabase } from './supabase'

export async function startPayment(orderId: string, checkoutToken: string): Promise<{ checkout_url: string }> {
  const { data, error } = await supabase.functions.invoke('efi-create-payment', {
    body: { order_id: orderId, checkout_token: checkoutToken }
  })
  if (error) throw new Error('Pagamento indisponível. Verifique a configuração da Efí Bank ou tente mais tarde.')
  if (!data || typeof data.checkout_url !== 'string' || !data.checkout_url.startsWith('https://')) {
    throw new Error(data?.error || 'O provedor de pagamento não retornou um checkout válido.')
  }
  const host = new URL(data.checkout_url).hostname
  if (!host.endsWith('.gerencianet.com.br') && !host.endsWith('.efipay.com.br')) throw new Error('A Efí retornou um endereço de pagamento não autorizado.')
  return { checkout_url: data.checkout_url }
}
